import {
    createApp
} from 'vue'
import App from './App.vue'
// 引入axios
import axios from 'axios';
// 引入vuex
import store from './store/index.js'
// 引入路由
import router from './router/index'
//引入element-plus组件及图标
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ELIcons from '@element-plus/icons-vue'
// 全局注入常量数据
import constGlobal from './common/global.js'
// 拖拽弹窗，在需要用到拖拽功能的弹窗标签上加v-dialogDrag
import dialogDrag from './common/dialogDrag.js'
// 引入自定义样式，覆盖element样式
import './assets/css/global.css'
import $ from 'jquery'

window.jQuery = $
window.$ = $
const app = createApp(App)

// 全局注册icon
for (let iconName in ELIcons) {
    app.component(iconName, ELIcons[iconName])
}
app.use(store).use(router).use(dialogDrag).use(ElementPlus, {
    size: 'default'
}).mount('#app')
app.config.globalProperties.$axios = axios; //配置axios的全局引用
app.config.productionTip = false;
// 挂载到实例上 vue3废除了prototype
app.config.globalProperties.$constGlobal = constGlobal;
//去掉控制台的warn信息
app.config.warnHandler = () => null